import React from 'react'
import { useAppContext } from '../../context/siteMapContext'
import { IMedia } from '../../interfaces/media'
import AudioItem from './audioItem.component'
import ImageItem from './imageItem.component'
import VideoItem from './videoItem.component'
import EmbeddedVideoItem from './embeddedVideoItem'

interface IParagraph {
  content: string
}
export const Paragraph: React.FC<IParagraph> = ({ content = '' }) => {
  return (
    <div
      className='w-full last:mb-[8px] text-article text-ellipsis overflow-hidden'
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}

interface IHighlightedText {
  content: string
}
export const HighlightedText: React.FC<IHighlightedText> = ({
  content = '',
}) => {
  const { highContrastOn } = useAppContext();
  return (
    <div
      className={`w-full last:mb-[8px] text-article break-all ${highContrastOn ? '' : 'article-block-highlight'}`}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}
interface IQuote {
  content: string
}
export const Quote: React.FC<IQuote> = ({ content = '' }) => {
  return (
    <div
      className='w-full pl-10 last:mb-[8px] text-article border-l-2 border-black italic break-all'
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}

interface ISubtitle {
  content: string
}
export const Subtitle: React.FC<ISubtitle> = ({ content = '' }) => {
  return (
    <div
      className='w-full last:mb-[8px] text-article font-semibold'
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}

interface IMediaContent {
  media: IMedia
}
export const MediaContent: React.FC<IMediaContent> = ({ media }) => {
  return (
    <div className='w-full flex justify-center last:mb-[0px]'>
      <div className='w-full xl:w-1/2'>
        {media.type === 'IMAGE' && (
          <div className='h-[50vw] xl:h-[25vw]'>
            <ImageItem url={media.fileUrl} title={media.title} />
          </div>
        )}
        {media.type === 'VIDEO' && (
          <div className='h-[50vw] xl:h-[25vw]'>
            <VideoItem url={media.fileUrl} title={media.title} />
          </div>
        )}
        {media.type === 'EMBEDDEDVIDEO' && (
          <div className='h-[50vw] xl:h-[25vw]'>
            <EmbeddedVideoItem fileUrl={media.fileUrl} />
          </div>
        )}
        {media.type === 'AUDIO' && (
          <AudioItem url={media.fileUrl} title={media.title} innerDescription={media.innerDescription} />
        )}
      </div>
    </div>
  )
}

interface IEmbeddedVideo {
  content: string
}
export const EmbeddedVideo: React.FC<IEmbeddedVideo> = ({ content = '' }) => {
  return (
    <div className='w-full flex justify-center last:mb-[15px]'>
      <div
        className='w-full xl:w-1/2'
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  )
}

interface ITable {
  content: string
}
export const Table: React.FC<ITable> = ({ content = '' }) => {
  return (
    <div
      className='w-full xl:-mx-[8.3vw] xl:w-[125%] flex justify-center last:mb-[8px] article-block-table'
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}
